import router from './index';
// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
// 语言包-加载成功才 next
import { languageStatus } from '@/lang';
// store
// import store from '../store';
// local
import local from '../data/local';
// cookie
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false })

router.beforeEach(async (to, from, next) => {
	// 设置网站title
	let lang = Cookies.get('lang') ? Cookies.get('lang') : 'zh-cn';
	let langtitle = {
        // 'zh-cn': '临研数字化智库平台 -【成都六人行信息科技有限公司】',
        'zh-cn': '临研数字化智库平台',
		'en-us': 'digitalgcp'
	}
	if (to.meta && to.meta.title && to.meta.title[lang]) {
		document.title = to.meta.title[lang];
	} else {
		document.title = langtitle[lang]; 
	}
	// 不需要登录的模块
	var other = to.name?.startsWith('other_'); // other模块放行
	if (other) {
		return next();
	}
	// 登录操作
	// if (!local.value.token && to.query.token) {
	// 	let params = {
	// 		token: to.query.token,
	// 	}
	// 	store.dispatch('http_post', { url: '/login/auth', payload: params }).then((res) => {
	// 		if (res.state == 40100) {
	// 			// 写入 token
	// 			local.set({
	// 				id: res.data.token,
	// 				uid: res.data.uid,
	// 				token: res.data.token,
	// 			});
	// 			// 重定向到登陆前页面
	// 			return next({
	// 				path: '/research_center'
	// 			});
	// 		}
	// 	});
	// }
	// 路由-控制
	switch (to.name) {
        case 'index':
        case 'login':
        case 'apply':
			if (local.value.token) {
				return next({
					path: '/research_center'
				});
			}
			break;
		default:
			// 如果没有token
			if (!local.value.token) {
				if (to.name != 'index' && to.name != 'login') {
					return next({
						path: '/'
					})
				}
			}
	}


	NProgress.start();

	// 等待语言包加载成功
	await languageStatus.waitLoaded();

	next();
})
router.afterEach(() => {
	// 路由切换后，滚动条置顶
	window.scrollTo(0, 0);

	NProgress.done();
})

router.onError(() => {
	NProgress.done();
})